export default "__VITE_ASSET__Dhau1SP4__"